import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background-color: var(--paper-raised);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  padding: 24px;
  margin-bottom: 20px;
  max-width: 700px;
`;

const CardHeader = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--ink);
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--line);
`;

const CardContent = styled.div`
  font-size: 14px;
  color: var(--ink-soft);
  line-height: 1.6;
`;

const SectionBlock = ({ title, children, style }) => {
  return (
    <Card style={style}>
      {title && <CardHeader>{title}</CardHeader>}
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};

export default SectionBlock;